import { atom, useAtom } from "jotai";

const isOpenAtom = atom<boolean>(false);
export const useIsOpenAtom = () => useAtom(isOpenAtom);
